export default {
  modelName: 'answer_setting_item',
  label: '選項',
  fields: {
    optionItem: {
      type: 'optionItem',
      fields: {
        locales: {
          type: 'locales',
          fields: {
            name: {
              label: '選項名稱',
              type: 'text',
              rules: 'required',
              maxlength: 30,
              displayLabel: false,
            },
          },
        },
        risk_level: {
          type: 'select',
          placeholder: '設定風險等級',
          items: [
            {
              value: '21',
              text: '低風險',
            },
            {
              value: '22',
              text: '中風險',
            },
            {
              value: '23',
              text: '高風險',
            },
            {
              value: '25',
              text: '無異常',
            },
          ],
        },
        has_remark: {
          type: 'checkbox',
          label: '選答時要求必填備註',
          items: [
            {
              value: [1],
              text: '選答時要求必填備註',
            },
          ],
          sm: 6,
        },
        has_child: {
          type: 'checkbox',
          label: '開啟次級選項',
          items: [
            {
              value: [1],
              text: '開啟次級選項',
            },
          ],
          sm: 6,
        },
      }
    },
  },
  fieldsRead: [
    'optionItem',
  ],
};
